import type { UserStateSavedSearchKey } from "./user-state";

export const EMAIL_ALERTS_ITEM_KEY = "emailAlerts" as const;
export const SAVED_SEARCH_ITEM_KEY_PREFIX = "savedSearch#" as const;

/** Identifier of the consent copy version shown at opt-in (spec §9). Bump when the copy changes. */
export const ALERTS_CONSENT_TEXT_VERSION = "alerts-consent-v1";

export const ALERT_FREQUENCIES = ["weekly", "daily"] as const;
export type AlertFrequency = (typeof ALERT_FREQUENCIES)[number];
export const DEFAULT_ALERT_FREQUENCY: AlertFrequency = "weekly";

export const EMAIL_ALERTS_STATUSES = ["active", "pendingConfirmation", "unsubscribed"] as const;
export type EmailAlertsStatus = (typeof EMAIL_ALERTS_STATUSES)[number];

export type AlertWithdrawalChannel = "profile" | "emailLink" | "oneClick" | "bounce" | "complaint";

export interface EmailAlertsData extends Record<string, unknown> {
  frequency: AlertFrequency;
  /** Captured from the session at opt-in; cleared on unsubscribe (spec §9). */
  email?: string;
  emailVerified: boolean;
  status: EmailAlertsStatus;
  locale: "en" | "fi" | "sv";
  /** Epoch ms of the last successful digest send; window lower bound. */
  lastSentAt: number | null;
  consentAt: number;
  consentTextVersion: string;
  consentSource: string;
  withdrawnAt?: number;
  withdrawnVia?: AlertWithdrawalChannel;
}

export interface SavedSearchItemData extends Record<string, unknown> {
  /** Normalized saved-search URL (utils/saved-searches/normalize-saved-search-url.ts). */
  url: string;
  label?: string;
  alertEnabled: boolean;
  createdAt: number;
}

export function isAlertFrequency(value: unknown): value is AlertFrequency {
  return typeof value === "string" && (ALERT_FREQUENCIES as readonly string[]).includes(value);
}

export function isEmailAlertsStatus(value: unknown): value is EmailAlertsStatus {
  return typeof value === "string" && (EMAIL_ALERTS_STATUSES as readonly string[]).includes(value);
}

export function savedSearchItemKey(id: string): UserStateSavedSearchKey {
  if (typeof id !== "string" || id.length === 0) {
    throw new Error("[email-alerts] saved search id must be a non-empty string");
  }
  return `${SAVED_SEARCH_ITEM_KEY_PREFIX}${id}`;
}
